import React, { useContext } from 'react'
import { AuthContext, ThemeContext } from '../../../auth';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Dropdown } from 'react-bootstrap';
import { BsGearFill } from 'react-icons/bs';
import { CiLogout } from 'react-icons/ci';
import { axiosAuth } from '../../../api';

function HeaderWeb() {

    const { setUserInfo, accessToken, setAccessToken } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);

    const navigate = useNavigate();

    const handleSubmitLogout = async () => {
        const confirmDelete = await Swal.fire({
            title: 'Keluar dari aplikasi?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Keluar',
            cancelButtonText: 'Batal',
        });

        if (!confirmDelete.isConfirmed) {

            return;
        }

        try {
            await axiosAuth.post(
                '/api/auth/logout',
                {},
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        withCredentials: true,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            sessionStorage.removeItem('userInfo');
            sessionStorage.removeItem('accessToken');
            setUserInfo();
            setAccessToken();

            Swal.fire({
                icon: 'success',
                title: 'Proses keluar berhasil!',
                showConfirmButton: false,
                timer: 2000,
            });
            navigate('/');
        } catch (error) {
            console.error(error)
            Swal.fire({
                icon: 'error',
                title: 'Warning!',
                text: 'Proses keluar gagal!',
            });
        }
    };

    return (
        <div className="container-logout-web" style={{ fontFamily: 'Poppins-Regular' }}>
            <Dropdown style={{ marginLeft: '0px' }}>
                <Dropdown.Toggle variant="btn" data-bs-theme={theme === 'light' ? 'dark' : ''} style={{ borderRadius: '0px', border: 'none', boxShadow: 'none' }}>
                    <BsGearFill size={18} color={theme === 'light' ? '#FFFFFF' : '#222222'} />
                </Dropdown.Toggle>
                <Dropdown.Menu id={theme === 'light' ? 'dropdownMenuDark' : 'dropdownMenuLight'}>
                    <Dropdown.Item
                        id={theme === 'light' ? 'dropdownItem1Dark' : 'dropdownItem1Light'}
                        className="d-flex align-items-center justify-content-center my-3"
                        onClick={handleSubmitLogout}
                    >
                        <CiLogout size={25} className='me-2' color={theme === 'light' ? '#FFFFFF' : '#707070'} />
                        <span style={{ fontFamily: 'Poppins-Light', color: theme === 'light' ? '#FFFFFF' : '#707070' }}>Keluar</span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default HeaderWeb
